import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/security/authentication.service';
import { IdentityService } from '../services/security/identity.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private _authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this._authenticationService.isAuthenticated()) {
            // logged in so return true
            console.log('AuthGuard is Authentic true');
            return true;
        } else {
            localStorage.clear();
            this._authenticationService.goToLogin();
            return false;
        }
    }
}